// Client for the same-origin contact relay (Cloudflare Pages Functions in
// functions/api/*). The marketing site is static, so form submissions POST to
// /api/* and the function relays them (Telegram bot, same mechanism as the
// other frontend_home sites).
const CONTACT_ENDPOINT = '/api';

// Which marketing site this build is — tags the enquiry so the message says
// where it came from.
const SITE = 'qasc.it';

async function post(path, payload) {
  let res;
  try {
    res = await fetch(`${CONTACT_ENDPOINT}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...payload, site: SITE }),
    });
  } catch {
    throw new Error('Errore di rete. Riprova oppure scrivi a info@qasc.it.');
  }
  if (!res.ok) {
    let msg = 'Qualcosa è andato storto. Riprova oppure scrivi a info@qasc.it.';
    try {
      const data = await res.json();
      if (data && data.error) msg = data.error;
    } catch {
      /* keep default */
    }
    throw new Error(msg);
  }
  return res.json().catch(() => ({}));
}

// { name, surname, email, message, company? } — company is an unused honeypot.
export function sendContactEnquiry(data) {
  return post('/contact', data);
}

export function subscribeNewsletter(email, extra = {}) {
  return post('/subscribe', { email, ...extra });
}
